<template>
    <a @click="addBlock" class="rr-builder-preview uk-box-shadow-hover-large">
        <figure class="rr-builder-preview__media">
            <img :src="template.preview" :alt="template.description">
        </figure>
        <div class="rr-builder-preview__caption">{{ template.description }}</div>
        <div ref="markup" class="uk-hidden">
            <slot name="markup"> </slot>
        </div>
    </a>
</template>

<style lang="less">
    @import (reference) "~less/app";
    @import "~rubinred/content/less/rubinred-builder";

    .rr-builder-preview {
        @rr-builder-preview-bg: #ffffff;
        @rr-builder-preview-bg-secondary: #f9f9f9;
        @rr-builder-preview-shadow: #000000;
        @rr-builder-preview-padding: 10px;
        @rr-builder-preview-radius: 0;

        display: block;
        text-decoration: none;
        background: @rr-builder-preview-bg;
        border: 1px solid @rr-builder-preview-bg-secondary;
        border-radius: @rr-builder-preview-radius;
        box-shadow: 0 2px 4px fade(@rr-builder-preview-shadow, 10%);
        transition: box-shadow 0.3s ease;

        &:hover,
        &:focus {
            text-decoration: none;
        }

        &__media {
            display: block;
            margin: 0;
            padding: @rr-builder-preview-padding;
        }

        &__caption {
            display: block;
            padding: @rr-builder-preview-padding;
            color: @global-color;
            font-size: @global-font-size;
            line-height: 1;
            text-align: center;
            text-decoration: inherit;
            background-color: @rr-builder-preview-bg-secondary;
            border-bottom-right-radius: @rr-builder-preview-radius;
            border-bottom-left-radius: @rr-builder-preview-radius;
        }
    }
</style>

<script>
  export default {
    props: [ 'preview', 'description' ],
    data() {
      return {
        template: {
          preview: 'https://placehold.co/768x400/eeeeee?text=placeholder',
          description: 'Block',
          markup: '',
        }
      }
    },
    mounted(){
      this.template.markup = this.$refs.markup.innerHTML;
      if (this.preview) {
        this.template.preview = this.preview;
      }
      if (this.description) {
        this.template.description = this.description;
      }
    },
    methods: {
      addBlock(){
        this.$root.$emit('close-add-block-modal');
        this.$root.$emit('add-block', {
          content: this.template.markup
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/content/assets/js/components/BuilderTemplate.vue